import { apiPost } from '@/lib/http/client';
import { logger } from '@/lib/logger';

import {
  ERROR_VOLUME_BEACON_TIMEOUT_MS,
  ERROR_VOLUME_ENDPOINT,
} from './config';
import type { ErrorVolumeBeaconPayload, ErrorVolumeSnapshot } from './types';

/**
 * Post one drained window.
 *
 * Fire-and-forget, matching sendViewHealthBeacon and trackTiming: never
 * awaited, failures logged and swallowed.
 *
 * Swallowing matters more here than for the other beacons. This module counts
 * errors, so a beacon that surfaced its own failure as an unhandled rejection
 * would count itself and grow the next window — a feedback loop that would make
 * the numbers useless precisely when the network is unhealthy. The `.catch`
 * below is what keeps that loop closed; do not remove it.
 */
export function sendErrorVolumeBeacon(snapshot: ErrorVolumeSnapshot): void {
  const payload: ErrorVolumeBeaconPayload = {
    window_ms: snapshot.windowMs,
    raw: snapshot.raw,
    unique: snapshot.unique,
  };

  logger.debug('Error volume beacon sent', {
    window_ms: payload.window_ms,
    raw: payload.raw,
    unique: payload.unique,
  });

  apiPost(ERROR_VOLUME_ENDPOINT, payload, ERROR_VOLUME_BEACON_TIMEOUT_MS).catch(
    (err: unknown) => {
      logger.warn('Error volume beacon failed', { error: String(err) });
    }
  );
}
